import { BuiedPointClick_Fn } from "../assets/js/BuriedPointEvent"
import { isUserEdit } from "../assets/js/common"

const monthage = {
  '1': "备孕",
  '2': "怀孕",
  '3': "0-6个月",
  '4': "6-12个月",
  '5': "12-36个月",
  '6': "3岁以上"
}

function getAge(){
  if (isUserEdit()) {
    const babyNums = localStorage.getItem("babyNums");
    const babyInfo = JSON.parse(localStorage.getItem("babyInfo"));
    const currentBaby = babyInfo.find(item => item.num == babyNums)
    return currentBaby && monthage[currentBaby.tag_id]
  }else {
    return null
  }
}


// 0元试用曝光埋点
export const freetrialView = async (params) => {
  // await getAge()
  BuiedPointClick_Fn(
    'xmhh5_Freetrial_view',
    Object.assign({
      xmhh5_Freetrial_monthage: await getAge() || ""
    }, params)
  )
}

// 0元试用点击埋点
export const freetrialClick = async (params) => {
  BuiedPointClick_Fn(
    'xmhh5_Freetrial_click',
    Object.assign({
      xmhh5_Freetrial_monthage: await getAge() || ""
    }, params)
  )
}



